import React, { useCallback } from 'react';
import '../../utils/assertions.es.js';
import { warn, runIfFn } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
import { useImage } from './useImage.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Image = forwardRef((props, ref) => {
  const _a = props, { as = "img", src, srcSet, fallbackSrc, fallbackHandler, fallback, onLoad, onError } = _a, rest = __objRest(_a, ["as", "src", "srcSet", "fallbackSrc", "fallbackHandler", "fallback", "onLoad", "onError"]);
  const status = useImage(props);
  warn({
    condition: !!fallbackHandler,
    message: "The `fallbackHandler` prop is deprecated and will be removed in v1, use `fallback` instead"
  });
  const getFallback = useCallback(() => {
    if (fallback) {
      return runIfFn(fallback);
    }
    if (fallbackHandler && status.isFailed)
      return runIfFn(fallbackHandler);
    return /* @__PURE__ */ React.createElement(Box, __spreadValues({
      as,
      ref,
      src: fallbackSrc
    }, rest));
  }, [as, fallback, fallbackHandler, fallbackSrc, ref, rest, status.isFailed]);
  if (src) {
    if (status.isFailed) {
      return getFallback();
    }
  } else if (!src) {
    if (status.isFailed || status.isPending) {
      return getFallback();
    }
  }
  return /* @__PURE__ */ React.createElement(Box, __spreadValues({
    as,
    ref,
    src,
    srcSet
  }, rest));
});
Image.displayName = "Image";
Image.defaultProps = {
  draggable: false
};

export { Image };
//# sourceMappingURL=Image.es.js.map
